var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-9 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(9 10)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 25,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 23,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Jun",
    transform: "translate(24.5 28)",
    fill: "#707070",
    stroke: "rgba(112,112,112,0)",
    strokeWidth: 1,
    fontSize: 11,
    fontFamily: "LucidaGrande-Bold, Lucida Grande",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.526,
    y: 0
  }, "Jun")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(14 8)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(30 8)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    transform: "translate(10 17)",
    fill: "rgba(255,255,255,0)",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill",
    width: 28,
    height: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0h28M27,0v1M28,1h-28M1,1v-1",
    fill: "none",
    clipPath: "url(#clip)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(30 25)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 4.5,
    transform: "translate(36.5 28)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 3,
    y2: 2,
    transform: "translate(36 30)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTime);
export default __webpack_public_path__ + "static/media/calendar-time.052dad61ef5abf97088015a3d2ac509f.svg";
export { ForwardRef as ReactComponent };